import { render, staticRenderFns } from "./statements.vue?vue&type=template&id=4f66e960&scoped=true&"
import script from "./statements.vue?vue&type=script&lang=js&"
export * from "./statements.vue?vue&type=script&lang=js&"
import style0 from "./statements.vue?vue&type=style&index=0&id=4f66e960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f66e960",
  null
  
)

export default component.exports